
$(".menu > ul > li:has( > ul)").addClass("menu-dropdown-icon");

$(".menu > ul > li > ul:not(:has(ul))").addClass("normal-sub");

$(".menu > ul > li").hover(function (e) {
    if ($(window).width() > 1049) {
        $(this).children("ul").stop(true, false).fadeToggle(150);
        e.preventDefault();
    }
});

$('.menu-item-has-children').on('click', function(e){
    if ($(window).width() <= 1049) {
        e.preventDefault();
    }
});

// Add click event listener to main menu items
$(".menu > ul > li").on('click', function (e) {
    if ($(window).width() <= 1049) {
        // e.preventDefault();
        $(this).children("ul").fadeToggle(150);
        $(this).toggleClass("submenu-toggled");
    }
});

// Add click event listener to subnav items
$(".menu > ul > li > ul > li").on('click', function (e) {
    if ($(window).width() <= 1049) {
        e.stopPropagation(); 
        $(this).parent().fadeToggle(150);
        $(this).parent().parent().removeClass("submenu-toggled");
    }
});


$(".burger").on('click', function (e) {
    $(".burger").toggleClass("open");
    $('body').toggleClass('mobile-menu-open');
    $(".menu > ul").toggleClass("show-on-mobile");
    e.preventDefault();
});

$("#mobile-contact").on('click', function() {
    $(".burger").removeClass("open");
    $('body').removeClass('mobile-menu-open');
    $(".menu > ul").removeClass("show-on-mobile");
})